// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  close: () => 'Затвори',
  error: () => 'Грешка',
  warn: () => 'Упозорење',
  info: () => 'Информације',
  confirmation: () => 'Потврда',
  progressIndeterminate: () => 'У току',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Између ' + p['FROM_SECTION'] + ' и ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Нису пронађени одељци који се подударају.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => "Притисните 'enter' да бисте изабрали вредност.",
  indexer_touchInstructionText: () =>
    'Двапут додирните и задржите да бисте прешли на режим гестикулације, а затим превуците нагоре или надоле да бисте прилагодили вредност.',
  inputPassword_show: () => 'Прикажи лозинку',
  inputPassword_hide: () => 'Сакриј лозинку',
  inputPassword_hidden: () => 'Лозинка је скривена',
  formControl_clear: () => 'Обриши',
  formControl_loading: () => 'Учитава се',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Максимална дужина од ' + p['MAX_LENGTH'] + ' је премашена.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Преостали број знакова је ' + p['CHARACTER_COUNT'] + '.',
  formControl_requiredMessageDetail: () => 'Унесите вредност.',
  select_requiredMessageDetail: () => 'Изаберите вредност.',
  select_noMatchesFound: () => 'Није пронађен ниједан погодак.',
  select_oneMatchFound: () => 'Пронађен је један резултат',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Пронађених подударања: ' + p['TOTAL_SIZE'],
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Пронађених подударања: ' + p['TOTAL_SIZE'] + ' или више',
  selectMultiple_selectedValues: () => 'Изабране вредности',
  selectMultiple_showSelectedValues: () => 'Приказују се само изабране вредности.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Изабраних вредности: ' + p['VALUE_COUNT'] + ' .',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Притисните тастере Backspace или Delete да бисте уклонили изабрану вредност.',
  selectMultiple_apply: () => 'Примени',
  selectMultiple_back: () => 'Назад',
  selector_selected: () => 'Поље за потврду је означено',
  selector_unselected: () => 'Поље за потврду није означено',
  userAssistance_learnMore: () => 'Сазнајте више',
  userAssistance_required: () => 'Обавезно',
  filePicker_singleFileUploadError: () => 'Отпремајте једну по једну датотеку',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Не можете да отпремате датотеке типа ' + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Не можете да отпремате датотеке типа: ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'непознато',
  filePicker_dropzonePrimaryText: () => 'Превуците и отпустите',
  filePicker_dropzoneSecondaryText: () => 'Изаберите датотеку или је отпустите овде',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Изаберите или превуците датотеке овде',
  filePicker_addFiles: () => 'Додај датотеке',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Повећај',
  inputNumber_decrease: () => 'Смањи',
  inputNumber_converterParseError: () => 'Унесите број.',
  noData_message: () => 'Нема ставки за приказ',
  message_navigationFromMessagesRegion: () =>
    'Прелазак на област за поруке. Притисните F6 да бисте се вратили на елемент који је пре тога био у фокусу.',
  message_navigationToMessagesRegion: () =>
    'Област за поруке садржи нове поруке. Притисните F6 да бисте прешли на регион најновије поруке.',
  messageToast_allMessagesClosed: () => 'Све искачуће поруке су затворене.',
  expandableList_groupCollapse: () => 'Скупљено',
  expandableList_groupExpand: () => 'Проширено',
  expandableList_expandCollapseInstructionText: () =>
    'Користите стрелице да бисте проширивали и скупљали',
  list_suggestion: () => 'Предлог',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Корак ' + p['currentStep'] + ' од ' + p['numberOfSteps'],
  train_current: () => 'Тренутно',
  train_visited: () => 'Посећено',
  train_not_visited: () => 'Није посећено',
  train_message_type: () => 'Тип поруке',
  viz_drillable: () => 'Може да се детаљно анализира',
  dataVisualization_stateSelected: () => 'Изабрано',
  dataVisualization_stateUnselected: () => 'Неизабрано',
  dataVisualization_noData: () => 'Нема података за приказ'
};
export default bundle;
